import React, { memo, useCallback, useMemo } from 'react';

import colors from 'constants/colors';
import Literal from 'components/Literal';
import Scrollbar from 'components/ScrollBar';
import { Salesorders } from 'components/SvgIcons';
import { WidgetEmpty } from 'containers/components/widgets/Layouts';

import SalesOrdersWidgetRow from './SalesOrdersWidgetRow';

const SalesOrdersWidgetTable = memo(
    ({ counter, entityType, getSalesOrders, isVisible, list, refreshSalesOrders, tabSelected }) => {
        const handleScrollFrame = useCallback(
            (values) => {
                if (values.top === 1 && list.length < counter) {
                    getSalesOrders();
                }
            },
            [counter, getSalesOrders, list.length],
        );

        const emptyWidgetLiteral = useMemo(
            () =>
                tabSelected === 0
                    ? 'error_norelatedopensalesorders'
                    : 'error_norelatedclosedsalesorders',
            [tabSelected],
        );

        const shouldRenderEmpty = useMemo(
            () => !!(counter && (counter === 0 || counter === -1)),
            [counter],
        );

        const rows = useMemo(
            () =>
                list.map((current) => (
                    <SalesOrdersWidgetRow
                        key={current.id}
                        data={current}
                        entityType={entityType}
                        refreshSalesOrders={refreshSalesOrders}
                    />
                )),
            [entityType, list, refreshSalesOrders],
        );

        const emptyContent = useMemo(
            () => (
                <WidgetEmpty
                    icon={<Salesorders color={colors.grey[100]} />}
                    text={<Literal literal={emptyWidgetLiteral} />}
                />
            ),
            [emptyWidgetLiteral],
        );

        if (!isVisible) return null;

        return (
            <div className="sales-orders-widget-table">
                {!shouldRenderEmpty && (
                    <Scrollbar onScrollFrame={handleScrollFrame}>
                        <div className="sales-orders-widget-table-container">{rows}</div>
                    </Scrollbar>
                )}
                {shouldRenderEmpty && emptyContent}
            </div>
        );
    },
);

SalesOrdersWidgetTable.displayName = 'SalesOrdersWidgetTable';

export default SalesOrdersWidgetTable;
